import { Column } from "@components/Layout";
import { styled } from "solid-styled-components";

export const CommentWrapper = styled(Column)<{ even?: boolean }>`
  ${({ theme, even }) => (even ? `background: ${theme?.tracklist.trackEven}` : "")};
`;
